/*
    Adding some basic helper functions, though these ought to really be
    utility functions available from an IIFE application-wide

    TODO: .eslintrc -> "no-extend-native": 2, // disallow adding to native types
 */

String.prototype.contains = function (term) {
    return this.toLowerCase().indexOf(term.toLowerCase()) > -1;
};

String.prototype.capitalizeWord = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

var round = Math.round;
Math.round = function (value, decimals) {
    decimals = decimals || 0;
    return Number(round(value + 'e' + decimals) + 'e-' + decimals);
};


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}